import { CopyKey } from '../../../i18n';

export const EDUCATION_ITEMS_COPY_KEYS = [
    'identification.banner.education.lots_of_categories_label',
    'identification.banner.education.quality_fast_work_label',
    'identification.banner.education.audience_label',
] satisfies CopyKey[];

export const GO_EDUCATION_ITEMS_COPY_KEYS = [
    'identification.banner.education.variant_go.list.one',
    'identification.banner.education.variant_go.list.two',
    'identification.banner.education.variant_go.list.three',
] satisfies CopyKey[];
